import React, { useEffect } from "react";
import StarterOptionLink from "../../components/StarterOptionLink";
import StarterContainer from "../../components/StarterContainer";
import { usePrivate } from "@/contexts/PrivateContext";
import { AuthRole } from "@/services/shared/auth/auth.interfaces";
import { useNavigate } from "react-router-dom";

const HomeRouter = () => {
  const { isLoggedIn, isLoaded, role } = usePrivate();
  const nav = useNavigate();

  useEffect(() => {
    if (isLoaded && isLoggedIn) {
      switch (role) {
        case AuthRole.Student:
          nav("/student/dashboard");
          break;

        case AuthRole.Teacher:
          nav("/teacher/dashboard");
          break;

        case AuthRole.Admin:
          nav("/admin/dashboard");
          break;
      }
    }
  }, [isLoggedIn, isLoaded, role]);

  return <HomeContent />;
};

const HomeContent = () => {
  return (
    <StarterContainer>
      <StarterOptionLink
        title="Já sou aluno"
        subtitle="Acessar área de aluno"
        to="/login"
      />
      <StarterOptionLink
        title="Quero ser aluno"
        subtitle="Conheça os cursos disponíveis"
        to="/signup"
      />
    </StarterContainer>
  );
};

export const HomePage = () => {
  return <HomeRouter />;
};
